// Module
var code = `<template>
  <require from="./portfolio-overview-by-type-widget.scss"></require>

  <div class="portfolio-overview-by-type-widget portfolio-overview-by-type-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="hidePaging">
      .portfolio-overview-by-type-widget-\${id} .ag-paging-panel {
        display: none !important;
      }
    </style>

    <style>
      .portfolio-overview-by-type-widget-\${id} .ag-header,
      .portfolio-overview-by-type-widget-\${id} .ag-cell {
        font-size: \${fontSize}px !important;
      }

      .portfolio-overview-by-type-widget-\${id} .ag-cell {
        line-height: \${rowHeight}px !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <ag-grid-aurelia if.bind="!error" class="\${isInDashboard && themeService.darkTheme ? 'ag-theme-balham-dark' : 'ag-theme-balham ag-theme-balham-report'}" grid-options.bind="gridOptions">

      <ag-grid-column header-name="Portfolio (MNOK)" field="group" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Kostpris" field="costPrice" type="rightAligned" editable="false" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name.bind="customerService.selectedDates.to | date:'dd.MM.yy'" field="estimatedValue" editable="false" type="rightAligned" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="Andel" field="costPricePercent" editable="false" type="amountOneDec"></ag-grid-column>

      <ag-grid-column header-name="Endring" field="estimatedValueChange" type="rightAligned" editable="false" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name.bind="customerService.selectedDates.from | date:'dd.MM.yy'" field="estimatedValueFrom" editable="false" type="rightAligned" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="P&L YTD" field="profitLossYearToDate" type="rightAligned" editable="false" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="P&L YTD %" field="profitLossYearToDatePercent" type="amountOneDec" editable="false"></ag-grid-column>

      <ag-loading-overlay-template>
        <mdc-circular-progress></mdc-circular-progress>
      </ag-loading-overlay-template>
    </ag-grid-aurelia>

    <message if.bind="error" class="portfolio-overview-by-type-widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;